import { render, staticRenderFns } from "./MailListItem.vue?vue&type=template&id=77c82933&scoped=true"
import script from "./MailListItem.vue?vue&type=script&lang=js"
export * from "./MailListItem.vue?vue&type=script&lang=js"
import style0 from "./MailListItem.vue?vue&type=style&index=0&id=77c82933&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c82933",
  null
  
)

export default component.exports